import type { IconName } from '@/content/icons';
import { ICON_PATHS } from '@/content/icons';

export interface IconProps {
  name: IconName;
  /** 像素尺寸，默认 20。描边宽度会随尺寸等比放大，保持视觉一致。 */
  size?: number;
  className?: string;
  /** 有 title 时图标参与无障碍树，否则视为纯装饰。 */
  title?: string;
}

export function Icon({ name, size = 20, className, title }: IconProps) {
  const strokeWidth = size >= 32 ? 1.4 : 1.6;

  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
    >
      {title ? <title>{title}</title> : null}
      {ICON_PATHS[name].map((d) => (
        <path key={d} d={d} />
      ))}
    </svg>
  );
}
